import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../contexts/LanguageContext';

export default function Hero() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-white"
    >
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Ultra%20high%20resolution%20morning%20sunrise%20Hong%20Kong%20skyline%20dominated%20by%20towering%20modern%20glass%20skyscrapers%20and%20office%20buildings%20in%20foreground%20with%20small%20glimpse%20of%20Victoria%20Harbour%20water%20and%20distant%20mountain%20peaks%20as%20background%20accent%20warm%20golden%20sunlight%20reflecting%20on%20building%20facades%20bright%20cheerful%20atmosphere%20soft%20pastel%20sky%20colors%20professional%20architectural%20photography%20sharp%20details%20premium%20quality%208K%20clarity%20optimistic%20mood&width=1920&height=1080&seq=hero-hk-skyscrapers-dominant-morning-008&orientation=landscape)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center w-full">
        <div className="inline-flex items-center space-x-2 bg-gray-100 border border-gray-300 px-6 py-3 rounded-full mb-8 shadow-sm">
          <div className="w-2 h-2 bg-gray-800 rounded-full animate-pulse"></div>
          <span className="text-gray-700 text-sm font-medium tracking-wide">
            {t('AI驱动 · 文化创新 · 情感科技', 'AI-Driven · Cultural Innovation · Emotional Technology')}
          </span>
        </div>

        <h1 className="text-5xl lg:text-7xl font-bold text-gray-900 leading-tight mb-8" style={{ fontFamily: "'Noto Sans SC', sans-serif" }}>
          {t('可画科技', 'ComiAI Technology')}
          <br />
          <span className="text-gray-800">
            {t('AI赋能 创意无界', 'AI Empowers Boundless Creativity')}
          </span>
        </h1>

        <p className="text-xl lg:text-2xl text-gray-700 font-light mb-12 max-w-3xl mx-auto leading-relaxed">
          {t(
            '融合人工智能与东方文化，打造新一代数字内容创作与情感交互平台',
            'Integrating artificial intelligence with Eastern culture to create next-generation digital content creation and emotional interaction platforms'
          )}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 mb-20">
          <button 
            onClick={() => navigate('/aicomic')}
            className="px-10 py-4 bg-gradient-to-r from-red-600 to-red-700 text-white text-base font-medium rounded-full hover:from-red-700 hover:to-red-800 hover:shadow-2xl transition-all whitespace-nowrap cursor-pointer"
          >
            {t('探索产品', 'Explore Products')}
          </button>
          <button 
            onClick={() => navigate('/contact')}
            className="px-10 py-4 bg-white border-2 border-gray-300 text-gray-800 text-base font-medium rounded-full hover:border-gray-400 hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
          >
            {t('联系我们', 'Contact Us')}
          </button>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          <div className="bg-white border border-gray-300 rounded-2xl p-6 hover:shadow-lg transition-all">
            <div className="text-3xl font-bold text-gray-900 mb-2">{t('8万+', '80K+')}</div>
            <div className="text-sm text-gray-600">{t('日创作任务', 'Daily Creation Tasks')}</div>
          </div>
          <div className="bg-white border border-gray-300 rounded-2xl p-6 hover:shadow-lg transition-all">
            <div className="text-3xl font-bold text-gray-900 mb-2">{t('数万', 'Tens of Thousands')}</div>
            <div className="text-sm text-gray-600">{t('全球用户', 'Global Users')}</div>
          </div>
          <div className="bg-white border border-gray-300 rounded-2xl p-6 hover:shadow-lg transition-all">
            <div className="text-3xl font-bold text-gray-900 mb-2">10+</div>
            <div className="text-sm text-gray-600">{t('国家和地区', 'Countries & Regions')}</div>
          </div>
          <div className="bg-white border border-gray-300 rounded-2xl p-6 hover:shadow-lg transition-all">
            <div className="text-3xl font-bold text-gray-900 mb-2">{t('10+项', '10+ Items')}</div>
            <div className="text-sm text-gray-600">{t('知识产权', 'Intellectual Property')}</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-gray-700"></i>
      </div>
    </section>
  );
}
